import { isDev, isLocal, isStaging } from './environment'

const LOCAL_PATH = 'localhost:19006'
const TLD = 'getupspace.com'

const DEV_PATH = `dev.${TLD}`
const STAGING_PATH = `stg.${TLD}`
const PRODUCTION_PATH = `app.${TLD}`

const PAGE_LINK = 'page.link'
const PROTOCOL = 'https://'
const DEV_LINK_PATH = `${PROTOCOL}upspacedev.${PAGE_LINK}`
const STG_LINK_PATH = `${PROTOCOL}upspacestg.${PAGE_LINK}`
const PROD_LINK_PATH = `${PROTOCOL}upspace.${PAGE_LINK}`

const DEV_IOS_BUNDLE_NAME = 'com.upswingfitness.app-dev'
const DEV_ANDROID_BUNDLE_NAME = 'com.upswingfitness.app_dev'
const STG_IOS_BUNDLE_NAME = 'com.upswingfitness.app-staging'
const STG_ANDROID_BUNDLE_NAME = 'com.upswingfitness.app_staging'
const PROD_BUNDLE_NAME = 'com.upswingfitness.app'

let fullPath = ''
let functionPath = ''
let dynamicLinkPath = ''
let iOSBundleName = DEV_IOS_BUNDLE_NAME
let androidBundleName = DEV_ANDROID_BUNDLE_NAME

if (isLocal) {
  fullPath = `http://${LOCAL_PATH}`
  functionPath = 'https://us-central1-upswing-fitness-develop.cloudfunctions.net'
  dynamicLinkPath = DEV_LINK_PATH
} else if (isDev) {
  fullPath = `https://${DEV_PATH}`
  functionPath = 'https://us-central1-upswing-fitness-develop.cloudfunctions.net'
  dynamicLinkPath = DEV_LINK_PATH
} else if (isStaging) {
  fullPath = `https://${STAGING_PATH}`
  functionPath = 'https://us-central1-upswing-fitness-staging.cloudfunctions.net'
  dynamicLinkPath = STG_LINK_PATH
  iOSBundleName = STG_IOS_BUNDLE_NAME
  androidBundleName = STG_ANDROID_BUNDLE_NAME
} else {
  fullPath = `https://${PRODUCTION_PATH}`
  functionPath = 'https://us-central1-upswing-fitness.cloudfunctions.net'
  dynamicLinkPath = PROD_LINK_PATH
  iOSBundleName = PROD_BUNDLE_NAME
  androidBundleName = PROD_BUNDLE_NAME
}

export const UPSPACE_FULL_PATH = fullPath
export const DYNAMIC_LINK_PATH = dynamicLinkPath

export const UPSPACE_FUNCTIONS_FULLPATH = functionPath

export const IOS_BUNDLE_NAME = iOSBundleName
export const ANDROID_BUNDLE_NAME = androidBundleName
